export const ACTIVITYGROUP_MODES = Object.freeze({
  INPUT: 'input',
  REVIEW: 'review',
  SECONDARY_INPUT: 'secondaryInput',
  NOT_READY: 'notReady',
})

export const _ = ''
